module.exports = __webpack_public_path__ + "static/media/IMG_1555.38c75da3.jpg";